<template>
    <div class="activity-indicator-spinner">
        <div class="activity-indicator-spinner1 activity-indicator-spinner" />
        <div class="activity-indicator-spinner2 activity-indicator-spinner" />
        <div class="activity-indicator-spinner3 activity-indicator-spinner" />
        <div class="activity-indicator-spinner4 activity-indicator-spinner" />
        <div class="activity-indicator-spinner5 activity-indicator-spinner" />
        <div class="activity-indicator-spinner6 activity-indicator-spinner" />
        <div class="activity-indicator-spinner7 activity-indicator-spinner" />
        <div class="activity-indicator-spinner8 activity-indicator-spinner" />
        <div class="activity-indicator-spinner9 activity-indicator-spinner" />
        <div class="activity-indicator-spinner10 activity-indicator-spinner" />
        <div class="activity-indicator-spinner11 activity-indicator-spinner" />
        <div class="activity-indicator-spinner12 activity-indicator-spinner" />
    </div>
</template>
